/*
 * Site keys for v3 and invisible v2 recaptchas
 * (checkbox v2 isolated in /src/component/common/recaptcha.vue)
 */

const siteKeys = {
    dev: {
        v2: '6LdwxqEaAAAAAER0KGkKYrRM3VnmQJfWVs3ILmI6',
        v3: '6LcNwqEaAAAAAKtQl_FrdX2stARy-7VsMu55Pow8',
    },
    prod: {
        v2: '6LeAxqEaAAAAADmxNnEnJl6jXQX2DQ7N3wzmHMWv',
        v3: '6LcixaEaAAAAADMdKNVOh2z35PitZGGC3JH5QeRP',
    },
};

export default siteKeys[
    ['dev', 'test'].includes(process.env.VUE_APP_ENV) ? 'dev' : 'prod'
];
